import { Directive } from '@angular/core';

@Directive({
  selector: '[cardItemTable]'
})
export class CardItemTableDirective {

  constructor() { }

}